import { IDB_rowRead, IDB_rowsDelete, IDB_rowsReadAll, IDB_rowsWrite } from './IDB.queries'
import { IDB_globalDb } from './IDB'
import type { Rpts_IReportStatusUpdate } from '../Rpts/Rpts.reportStatus.types'

export function IDB_reportStatusUpdatesRead(statusId: number) {
    return IDB_rowRead<Rpts_IReportStatusUpdate>(IDB_globalDb, 'report_status_updates', statusId)
}

export function IDB_reportStatusUpdatesDelete(statusId: number[]) {
    return IDB_rowsDelete(IDB_globalDb, 'report_status_updates', statusId)
}

export function IDB_reportStatusUpdatesReadAll() {
    return IDB_rowsReadAll<Rpts_IReportStatusUpdate>(IDB_globalDb, 'report_status_updates')
}

export function IDB_reportStatusUpdatesWrite(statuses: Rpts_IReportStatusUpdate[]) {
    return IDB_rowsWrite(IDB_globalDb, 'report_status_updates', statuses)
}
